import { useMutation } from "@tanstack/react-query";
import ky from "ky";
import { z } from "zod";

const SupportTicketSchema = z.object({
	email: z.string().email(),
	category: z.enum(["billing", "partner", "referral", "bug", "other"]),
	message: z.string().trim().min(1),
	turnstileToken: z.string().optional(),
	appId: z.string().optional(),
	partnerId: z.string().optional(),
	payoutId: z.string().optional(),
	environment: z.enum(["prod", "staging", "dev"]).optional(),
});

export type SupportTicketInput = z.infer<typeof SupportTicketSchema>;

/**
 * Submits a support ticket to the support gateway worker.
 * Uses ky for the HTTP request and useMutation for state management.
 */
export function useSupportApi() {
	return useMutation({
		mutationFn: async (data: SupportTicketInput) => {
			const response = await ky
				.post(`${import.meta.env.VITE_SUPPORT_API_URL}/support/ticket`, {
					json: data,
				})
				.json<{ ok: boolean }>();

			return response;
		},
	});
}
